const groups = new Map();

function debounce(fn, ms) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
}

function collectGroups() {
  groups.clear();
  document.querySelectorAll('[data-eq-height]').forEach(el => {
    const key = el.dataset.eqHeight;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(el);
  });
}

function equalizeGroup(els) {
  els.forEach(el => (el.style.minHeight = ''));
  const max = Math.max(...els.map(el => el.getBoundingClientRect().height));
  els.forEach(el => (el.style.minHeight = `${max}px`));
}

function equalizeAll() {
  groups.forEach(equalizeGroup);
}

function init() {
  collectGroups();
  equalizeAll();
}

document.addEventListener('DOMContentLoaded', init);
window.addEventListener('resize', debounce(equalizeAll, 100));
